export default __webpack_public_path__ + "static/media/slack-fullcolor.d13aa1ce.svg";